import { supabase } from '../lib/supabase';

export type UserSessionRecord = {
  id: string;
  user_id: string;
  device?: string;
  user_agent?: string;
  last_active?: string;
  created_at?: string;
};

const generateId = () => (typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : Math.random().toString(36).slice(2));

export async function recordSession(userId: string, userAgent?: string) {
  const sessionId = generateId();
  await supabase.from('user_sessions').upsert({
    id: sessionId,
    user_id: userId,
    user_agent: userAgent || 'browser',
    last_active: new Date().toISOString(),
  });
}

export async function fetchSessions(userId: string): Promise<UserSessionRecord[]> {
  const { data, error } = await supabase
    .from('user_sessions')
    .select('*')
    .eq('user_id', userId)
    .order('last_active', { ascending: false });

  if (error || !data) return [];
  return data as UserSessionRecord[];
}

export async function revokeSession(sessionId: string) {
  await supabase.from('user_sessions').delete().eq('id', sessionId);
}

export async function logoutOtherSessions() {
  // Supabase supports scope to log out other sessions
  await supabase.auth.signOut({ scope: 'others' as any });
}

export async function changePassword(newPassword: string) {
  const { error } = await supabase.auth.updateUser({ password: newPassword });
  if (error) throw error;
}

